var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#2babe2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 14.344,
    fill: "#2babe2",
    fillOpacity: 1,
    transform: "rotate(45 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 12.531,
    fill: "#2babe2",
    fillOpacity: 1,
    transform: "rotate(90 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 10.75,
    fill: "#2babe2",
    fillOpacity: 1,
    transform: "rotate(135 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 10.063,
    fill: "#2babe2",
    fillOpacity: 1,
    transform: "rotate(180 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 8.063,
    fill: "#2babe2",
    fillOpacity: 1,
    transform: "rotate(225 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 6.438,
    fill: "#2babe2",
    fillOpacity: 1,
    transform: "rotate(270 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 5.375,
    fill: "#2babe2",
    fillOpacity: 1,
    transform: "rotate(315 64 64)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64",
    calcMode: "discrete",
    dur: "720ms",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/loading-spinner.917d6f85555e33c507a478b6396f358c.svg";
export { ForwardRef as ReactComponent };